
import wx from 'weixin-js-sdk'

import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: 'secondCommunityEdit',
components: {
wx,XTextarea,Group
},
data() {
return {
formData:{
id:0,
title:'',
name:'',
phone:'',
reward:'',
clean_reward:'',
card_reward:'',
goods_reward:'',
content:'',
address:'请在地图上标注社区所在位置',
lat:'',
lng:''
},
}
},
created() {
this.formData.id = Number(this.$route.params.id);
this.config();
console.log(this.formData);
if(this.formData.id > 0){
this.getSecondCommunity();
}
},
beforeRouteLeave(to, from, next) {
if(to.name == 'maps'){
from.meta.keepAlive = true;
}else{
var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '') : this.$vnode.key
var cache = this.$vnode.parent.componentInstance.cache
var keys = this.$vnode.parent.componentInstance.keys
console.log(key,cache,keys);
if (cache[key]) {
if (keys.length) {
var index = keys.indexOf(key)
if (index > -1) {
keys.splice(index, 1)
}
}
delete cache[key]
}
}
next();
},
activated(){
if(this.$func.getSession('address')){
let address = JSON.parse(this.$func.getSession('address'));
this.formData.address = address.poiaddress;
this.formData.lat = address.latlng.lat;
this.formData.lng = address.latlng.lng;
this.$func.setSession('address','');
}
},
methods: {
getSecondCommunity() {
this.$api.getSecondCommunity({id:this.formData.id}).then((res)=>{
if(res){
this.formData = res.data;
}
})
},
submit() {
if(!this.formData.name){
this.$func.showToast('请输入社区名称');
return false;
}
if(!this.formData.head_name){
this.$func.showToast('请输入团长姓名');
return false;
}
if(!this.formData.head_phone){
this.$func.showToast('请输入团长电话');
return false;
}
if(!this.formData.reward){
this.$func.showToast('请输入洗衣分润');
return false;
}
if(!this.formData.card_reward){
this.$func.showToast('请输入会员卡分润');
return false;
}
if(!this.formData.clean_reward){
this.$func.showToast('请输入家政分润');
return false;
}
if(!this.formData.goods_reward){
this.$func.showToast('请输入商品分润');
return false;
}
if(!this.formData.lat || !this.formData.lng){
this.$func.showToast('请在地图上标注社区所在位置');
return false;
}
this.$api.submitSecondCommunity(this.formData).then((res)=>{
if(res){
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);
},300)
}
});
},
position(){
let that = this;
wx.getLocation({
type: 'gcj02',
success: function (res) {
that.$router.push({name:'maps',params:{latitude:res.latitude,longitude:res.longitude}})
}
});
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"getLocation",
]
});
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/secondCommunityEdit.vue